/* eslint-disable camelcase */
import React from 'react';
import TreeView from '../../GroupTreeView/GroupTreeView';
import { ITabParams } from '../../../config/types';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../redux/store';
import { openModulesTab } from './ModulesUtils';
import { triggerEvent } from '../../../redux/event';
import { fetchModuleGroups, fetchModules } from '../../../redux/module';
import {
  ModuleCollection,
  ModuleDocumentType
} from '@digitalworkflow/dwtranslateclient';
import { setSelectedNode } from '../../../redux/activeNode';
import {
  builderPageTypes as BPT,
  builderPageTypes
} from '../../../config/constants/builderPageTypes';
import { updateDataEverywhere } from '../../../utils';
import { ITreeViewData } from '@digitalworkflow/dwtranslateclient/lib/Models/Module/ModuleCollection';
import styles from '../Renderers.module.scss';

export const GroupsModules = ({
  ref,
  type,
  selectedRows,
  gridReferences,
  setCurrentEventAPI,
  setSelectedRowIndex,
  setSelectedRows,
  fetchData,
  setRowSelectedFlag,
  setTabsRef,
  updateData
}: ITabParams) => {
  const groups: ITreeViewData[] = useSelector(
    (state: RootState) => state.module.groups
  );
  const modules: any = useSelector((state: RootState) => state.module.modules);

  const dispatch = useAppDispatch();

  function reduxUpdater() {
    dispatch(fetchModules());
    dispatch(fetchModuleGroups());
  }

  function openForm() {
    dispatch(triggerEvent('showModalEvent'));
  }

  /**
   * callback to handle when a group is clicked in tree view
   * @param title string name of the group clicked
   */
  function handleGroupClick(title: string) {
    if (!modules[title]) return;

    const rows: Partial<ModuleDocumentType>[] = [];

    rows.push(modules[title].data);

    const tabId = title + '_tab';

    const tabAlreadyPresent = ref?.find(tabId);

    tabAlreadyPresent
      ? ref?.updateTab(tabId, null)
      : openModulesTab({
          ref,
          title,
          rows,
          firstTab: false,
          type,
          selectedRows,
          gridReferences,
          fetchData,
          setSelectedRows,
          setSelectedRowIndex,
          setCurrentEventAPI,
          setRowSelectedFlag,
          setTabsRef,
          updateData,
          updateMetaData: (data) => {
            updateDataEverywhere(
              ref,
              data.id,
              data,
              builderPageTypes.modules,
              reduxUpdater
            );
          }
        });

    dispatch(setSelectedNode(title));
  }

  async function handleDrop(newData: ITreeViewData[]) {
    for (let index = 0; index < newData.length; index++) {
      if (newData[index].parent !== groups[index].parent) {
        const parentIndex = newData.findIndex(
          (v) => v.id === newData[index].parent
        );
        await ModuleCollection.updateModuleParent(
          newData[index].text as string,
          newData[parentIndex].text as string
        );
        dispatch(fetchModuleGroups());
        break;
      }
    }
  }

  return (
    <div id={styles.treeView} className='overflow-y-auto h-100'>
      <TreeView
        pageType={BPT.modules}
        data={groups}
        setShowModal={() => openForm()}
        handleGroupClick={(title) => handleGroupClick(title)}
        handleDrop={(newTreeData: ITreeViewData[]) => handleDrop(newTreeData)}
        tabRef={ref}
      />
    </div>
  );
};

export const HistoryModules = () => {
  return (
    <div>
      <span>History available in V2</span>
    </div>
  );
};
